module.exports = __webpack_public_path__ + "media/armano_arm_curl.1bb3226f.mp4";